import React from "react";
import styled from "styled-components";
import viewPasswordIcon from "assets/images/view_password_icon.svg";
import hidePasswordIcon from "assets/images/hide_password_icon.svg";
import { getPasswordStrength } from "@kubera/common";

const Container = styled.div``;

const InputContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  border: ${props =>
    props.hasError === true ? "0.0625rem solid rgba(255, 0, 0, 0.4)" : "0.0625rem solid rgba(0, 0, 0, 0.4)"};
  box-sizing: border-box;
`;

const Input = styled.input`
  width: 100%;
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  font-feature-settings: "ss01" on;
  color: black;
  border: 0;
  padding-left: 0.8125rem;
  padding-right: 0.8125rem;
  outline: 0;
  background: transparent;

  &::placeholder {
    color: rgba(0, 0, 0, 0.4);
  }
`;

const InvalidPasswordMessage = styled.p`
  font-size: 0.6875rem;
  text-align: left;
  letter-spacing: 0.01em;
  color: ${props => props.theme.errorCLR};
  margin-block-start: 0.3125rem !important;
  margin-block-end: 0em !important;
`;

const PasswordToggleButton = styled.div`
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.9375rem;
  background-color: white;
  background-image: ${props =>
    props.isPasswordVisible === true ? `url("${hidePasswordIcon}")` : `url("${viewPasswordIcon}")`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  cursor: pointer;
`;

const PasswordStrengthIndicator = styled.div`
  width: 100%;
  height: 0.125rem;
  visibility: ${props => (props.visible === true ? "visible" : "hidden")};
  margin-right: 0.9375rem;
  margin-top: -0.0625rem;
  background-color: ${props => props.color};
`;

class PasswordInput extends React.Component {
  static minPasswordLength = 8;

  constructor(props) {
    super(props);

    this.state = { isPasswordVisible: false };
    this.inputRef = React.createRef();
    this.inputType = props.disableAutoComplete === true ? "new-password" : "password";
    this.handleFocus = this.handleFocus.bind(this);
    this.handlePasswordVisibilityToggleClick = this.handlePasswordVisibilityToggleClick.bind(this);
  }

  handleFocus(e) {
    if (this.inputType !== "password") {
      this.inputType = "password";
      this.inputRef.current.type = this.inputType;
    }
  }

  handlePasswordVisibilityToggleClick() {
    this.setState({ ...this.state, isPasswordVisible: !this.state.isPasswordVisible });

    const inputField = this.inputRef.current;
    if (inputField) {
      inputField.focus();
      setTimeout(() => {
        inputField.selectionStart = inputField.selectionEnd = inputField.value.length;
      }, 0);
    }
  }

  render() {
    const {
      className,
      type,
      onChange,
      value,
      hidePasswordStrength,
      errorMessage,
      inputError,
      disableAutoComplete,
      ...other
    } = this.props;
    const inputValue = value === null || value === undefined ? "" : value;
    const hasError = !errorMessage === false || inputError === true;
    const isPasswordVisible = this.state.isPasswordVisible;
    const passwordStrength = getPasswordStrength(value);
    const hidePasswordStrengthIndicator =
      !value === true || (!hidePasswordStrength === false && hidePasswordStrength === true);

    return (
      <Container className={className}>
        <InputContainer hasError={hasError}>
          <Input
            {...other}
            ref={this.inputRef}
            type={isPasswordVisible === true ? "text" : this.inputType}
            value={inputValue}
            onChange={this.props.onChange}
            onFocus={this.handleFocus}
            data-cy="password"
          />
          <PasswordToggleButton
            isPasswordVisible={isPasswordVisible}
            onClick={this.handlePasswordVisibilityToggleClick}
          />
        </InputContainer>
        <PasswordStrengthIndicator visible={!hidePasswordStrengthIndicator} color={passwordStrength.color} />
        {!errorMessage === false && <InvalidPasswordMessage>{errorMessage}</InvalidPasswordMessage>}
      </Container>
    );
  }
}

export default PasswordInput;
